export default "__VITE_ASSET__Bbqen8Wq__"